import React from 'react';

import { Text } from 'Modules/ui';
import { LanguageSelector } from 'Modules/core/i18n';

import { FactorinWindow } from '../FactorinWindow';
import { LogoutButton } from '../LogoutButton';
import styles from './index.module.scss';


export const LoginErrorWindow = ({ children }) => (
    <Text component={FactorinWindow} textType='light' className={styles.error}>
        <LanguageSelector classNames={{ languageSelector: styles.languageSelector }} />
        <span>
            {children}
        </span>
        <LogoutButton className={styles.button} resetRoute />
    </Text>
);
